import React, { createContext, useCallback, useContext } from 'react';
import api from '../services/api';

const TrackingContext = createContext({});

const TrackingProvider = ({ children }) => {
  const filterPickup = useCallback(async ({ params, subsidiaryOrigin }) => {
    const token = localStorage.getItem('@Braspress:token');

    const response = await api.get(
      `${process.env.REACT_APP_URL_MS_TRACKING}/pickup/v2/filter`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params
      }
    );

    if (response.status === 200) {
      return response.data.data;
    }

    return null;
  }, []);

  const findPickupById = useCallback(async ({ pickupId }) => {
    const token = localStorage.getItem('@Braspress:token');

    const response = await api.get(
      `${process.env.REACT_APP_URL_MS_TRACKING}/pickup/v1`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {
          pickupId
        }
      }
    );

    return response;
  }, []);

  const getPendingPickups = useCallback(async () => {
    const token = localStorage.getItem('@Braspress:token');

    const response = await api.get(
      `${process.env.REACT_APP_URL_MS_TRACKING}/pickup/pending/web`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    if (
      response.status === 200 &&
      response?.data?.data?.pendingPickups?.length > 0
    ) {
      const { pendingPickups } = response.data.data;

      return pendingPickups;
    }

    return [];
  }, []);

  const getPendingPickupsFilter = useCallback(async (params) => {
    const token = localStorage.getItem('@Braspress:token');

    const response = await api.get(
      `${process.env.REACT_APP_URL_MS_TRACKING}/pickup/v1/pending/web`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params
      }
    );

    if (response.status === 200 && response?.data?.data?.records?.length > 0) {
      // const { records } = response.data.data;

      return response.data.data;
    }

    return [];
  }, []);

  const contextValues = {
    filterPickup,
    findPickupById,
    getPendingPickups,
    getPendingPickupsFilter
  };

  return (
    <TrackingContext.Provider value={contextValues}>
      {children}
    </TrackingContext.Provider>
  );
};

function useTracking() {
  const context = useContext(TrackingContext);

  if (!context) {
    throw new Error('useTracking must be used within an TrackingProvider');
  }

  return context;
}

export { TrackingProvider, useTracking };
